export default {
  left_column: {
    title: 'Saldo controleren',
    description:
      'Voer uw cadeaukaartnummer in om het resterende saldo te controleren. De code staat op uw cadeaukaart-PDF.',
  },
  title: 'Cadeaukaart saldo controleren',
  subtitle: 'Voer een cadeaukaartcode in om het huidige saldo te controleren',
  error: {
    title: 'Cadeaukaart niet gevonden!',
    description: 'Voer een geldige cadeaukaartcode in.',
  },
  gift_card: {
    title: 'Cadeaukaart gevonden!',
    balance: 'Saldo',
    value: 'Waarde',
    expires_at: 'Verloopt op',
  },
  form: {
    code: {
      label: 'Cadeaukaartcode',
    },
  },
  buttons: {
    check_balance: 'Saldo controleren',
  },
};
